(function () {
  console.log("[InfiniteScroll] loaded");

  // Pages loadAhead() fetches at once. The letter collection (81 products, 36 per page)
  // collapses to 5 cards and needs pages 2 and 3; fetched one after the other they took
  // ~1s each on top of waiting for window load.
  const MAX_PAGES_AHEAD = 4;
  // Distance from the bottom of the page at which the next page is fetched.
  const NEAR_END_PX = 1200;
  // Sold-out ("Coming Soon") cards, which sections/main-collection-product-grid.liquid
  // renders into a <template> instead of the grid so they can go to the very bottom.
  const HELD_CARDS_SELECTOR = "template[data-searay-held-cards]";
  const GRID_ITEM_SELECTOR = "li.grid__item";

  let io = null;
  let onScroll = null;
  let mo = null;
  // Module-level so loadNext() and loadAhead() never fetch the same page twice.
  let loading = false;
  // Sold-out cards waiting for the last page, and the grid they belong to. A sort or
  // filter change swaps in a new grid, which starts with nothing held.
  let held = [];
  let heldList = null;

  function holdCards(list, cards) {
    if (list !== heldList) {
      heldList = list;
      held = [];
    }
    held.push(...cards);
  }

  // Page one's sold-out cards. Cloned rather than moved so each card's inline script
  // still runs when the card reaches the grid.
  function holdRenderedCards(list) {
    document.querySelectorAll(HELD_CARDS_SELECTOR).forEach((template) => {
      const content = document.importNode(template.content, true);
      holdCards(list, content.querySelectorAll(GRID_ITEM_SELECTOR));
      template.remove();
    });
  }

  // Once no page is left, the sold-out cards follow every in-stock one.
  function releaseHeldCards(list) {
    if (list !== heldList || !held.length) return;
    if (document.getElementById("InfiniteScroll")?.dataset?.nextUrl) return;
    held.forEach((li) => list.appendChild(li));
    held = [];
  }

  // Adds a fetched page to the grid. Returns false when the page had no grid, or the
  // grid was replaced (sort or filter change) while the page was on its way.
  function appendPage(list, page) {
    if (!page.items || !list.isConnected) return false;
    page.items.forEach((li) => list.appendChild(li));
    holdCards(list, page.held);
    document.getElementById("InfiniteScroll").dataset.nextUrl = page.nextUrl;
    releaseHeldCards(list);
    return true;
  }

  // A page that is mostly sold out adds few cards, which can leave the end of the grid
  // on screen with no scroll to trigger the next page. Runs after `loading` is cleared,
  // and only after a page arrived, so a failing request is not retried in a loop.
  function keepFilling() {
    setTimeout(() => window.dispatchEvent(new Event("scroll")), 0);
  }

  function cleanup() {
    if (io) {
      io.disconnect();
      io = null;
    }
    if (onScroll) {
      window.removeEventListener("scroll", onScroll);
      onScroll = null;
    }
  }

  function resolveList(appendSelector) {
    const el = document.querySelector(appendSelector);
    if (!el) return null;

    // If selector points to UL, good
    if (el.tagName === "UL" || el.tagName === "OL") return el;

    // If selector points to a container, find the UL inside
    return el.querySelector("ul.product-grid") || el.querySelector("ul.grid") || null;
  }

  function nearEnd() {
    const remaining =
      document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
    return remaining < NEAR_END_PX;
  }

  // Asks for the product grid section only (Section Rendering API) instead of the whole
  // page: the header's mega menu alone is ~340KB of HTML per page otherwise.
  function sectionUrl(url, list) {
    const u = new URL(url, window.location.origin);
    const sectionId = list.dataset.id || list.closest("[data-id]")?.dataset?.id;
    if (sectionId) u.searchParams.set("section_id", sectionId);
    return u.pathname + u.search;
  }

  async function fetchPage(url, list, appendSelector) {
    const html = await (await fetch(sectionUrl(url, list))).text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const nextSentinel = doc.getElementById("InfiniteScroll");
    const nextAppendSelector = nextSentinel?.dataset?.appendSelector || appendSelector;
    const el = doc.querySelector(nextAppendSelector);
    const nextList = !el
      ? null
      : el.tagName === "UL" || el.tagName === "OL"
        ? el
        : el.querySelector("ul.product-grid") || el.querySelector("ul.grid");

    return {
      items: nextList ? [...nextList.querySelectorAll(GRID_ITEM_SELECTOR)] : null,
      held: [...doc.querySelectorAll(HELD_CARDS_SELECTOR)].flatMap((template) => [
        ...template.content.querySelectorAll(GRID_ITEM_SELECTOR)
      ]),
      nextUrl: nextSentinel?.dataset?.nextUrl || ""
    };
  }

  // Fetches up to MAX_PAGES_AHEAD pages in parallel and appends them in page order.
  // Called by assets/searay-length-grouping.js when collapsing a grid leaves it too
  // short to scroll, so the grid fills in one round trip rather than one per page.
  // Returns false only when this grid cannot load ahead (no page count on the sentinel),
  // so the caller can fall back to a scroll nudge.
  function loadAhead() {
    const sentinel = document.getElementById("InfiniteScroll");
    const nextUrl = sentinel?.dataset?.nextUrl;
    if (!nextUrl) return true;

    const first = new URL(nextUrl, window.location.origin);
    const firstPage = parseInt(first.searchParams.get("page"), 10);
    const totalPages = parseInt(sentinel.dataset.totalPages, 10);
    if (!firstPage || !totalPages) return false;

    const appendSelector = sentinel.dataset.appendSelector || "#product-grid ul.product-grid";
    const list = resolveList(appendSelector);
    if (list && !loading && nearEnd()) loadPages(first, firstPage, totalPages, list, appendSelector);
    return true;
  }

  async function loadPages(first, firstPage, totalPages, list, appendSelector) {
    const lastPage = Math.min(totalPages, firstPage + MAX_PAGES_AHEAD - 1);

    const urls = [];
    for (let page = firstPage; page <= lastPage; page++) {
      first.searchParams.set("page", page);
      urls.push(first.pathname + first.search);
    }

    loading = true;
    console.log("[InfiniteScroll] loading ahead", urls);
    try {
      const pages = urls.map((url) => fetchPage(url, list, appendSelector));
      for (const pending of pages) {
        if (!appendPage(list, await pending)) break;
      }
      console.log("[InfiniteScroll] nextUrl ->", document.getElementById("InfiniteScroll")?.dataset?.nextUrl);
      keepFilling();
    } catch (e) {
      console.error("[InfiniteScroll] error", e);
    } finally {
      loading = false;
    }
  }

  function init() {
    cleanup();

    const sentinel = document.getElementById("InfiniteScroll");
    if (!sentinel) return console.log("[InfiniteScroll] no sentinel");

    const appendSelector = sentinel.dataset.appendSelector || "#product-grid ul.product-grid";
    const list = resolveList(appendSelector);
    if (!list) return console.log("[InfiniteScroll] no list", appendSelector);

    holdRenderedCards(list);
    releaseHeldCards(list);

    let nextUrl = sentinel.dataset.nextUrl || null;

    console.log("[InfiniteScroll] init", { nextUrl, appendSelector });

    async function loadNext() {
      // Re-read nextUrl every time (because facets replace HTML, and loadAhead() moves it).
      // An emptied sentinel means the last page is in; falling back to the local copy would
      // fetch that page again.
      const current = document.getElementById("InfiniteScroll");
      if (current) nextUrl = current.dataset.nextUrl || "";

      if (!nextUrl || loading) return;
      loading = true;

      console.log("[InfiniteScroll] loading", nextUrl);

      try {
        const page = await fetchPage(nextUrl, list, appendSelector);

        if (!page.items) {
          console.log("[InfiniteScroll] next list not found");
          document.getElementById("InfiniteScroll").dataset.nextUrl = "";
          releaseHeldCards(list);
          return;
        }

        console.log("[InfiniteScroll] appending", page.items.length);
        if (!appendPage(list, page)) return;

        console.log("[InfiniteScroll] nextUrl ->", page.nextUrl);
        keepFilling();
      } catch (e) {
        console.error("[InfiniteScroll] error", e);
      } finally {
        loading = false;
      }
    }

    io = new IntersectionObserver(
      (entries) => entries.some((e) => e.isIntersecting) && loadNext(),
      { rootMargin: NEAR_END_PX + "px 0px" }
    );
    io.observe(sentinel);

    onScroll = () => {
      if (nearEnd()) loadNext();
    };
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function bindMutationObserver() {
    const container = document.getElementById("ProductGridContainer");
    if (!container) return;

    if (mo) mo.disconnect();
    mo = new MutationObserver(() => {
      // Dawn swapped grid HTML -> re-init with new sentinel & new list
      setTimeout(init, 0);
    });
    mo.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      init();
      bindMutationObserver();
    });
  } else {
    init();
    bindMutationObserver();
  }

  // Also handle Dawn event (when it fires)
  document.addEventListener("facet-filters-form:render", () => setTimeout(init, 0));

  // Sold-out cards rendered on this page but not in the grid yet, for scripts that need
  // to know every product the page returned (assets/sku-search-fallback.js).
  function heldCards() {
    const waiting = [...document.querySelectorAll(HELD_CARDS_SELECTOR)].flatMap((template) => [
      ...template.content.querySelectorAll(GRID_ITEM_SELECTOR)
    ]);
    return held.concat(waiting);
  }

  window.SearayInfiniteScroll = { loadAhead, heldCards };
})();
